import { IconProps } from "@/data/types";

export default function EmptyBoxIcon({ width = 35, height = 35, color = "#696e75", className }: IconProps) {
  return (
    <div className={className}>
      <svg 
        version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 32 32" xmlSpace="preserve" width={width} height={height} fill={color}
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <style type="text/css">
            {`.st0{fill:none;stroke:${color};stroke-width:0.96;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
              .st1{fill:none;stroke:${color};stroke-width:0.96;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3;}
              .st2{fill:none;stroke:${color};stroke-width:0.96;stroke-linejoin:round;stroke-miterlimit:10;}
              .st3{fill:none;}`}
          </style>

          <polyline className="st0" points="26,18 26,24 16,28 6,24 6,18" />
          <polygon className="st0" points="6,12 16,8 26,12 16,16" />
          <polyline className="st0" points="16,8 13,5 3,9 6,12" />
          <polyline className="st0" points="16,8 19,5 29,9 26,12" />
          <polyline className="st0" points="6,12 3,16 13,20 16,16" />
          <polyline className="st0" points="26,12 29,16 19,20 16,16" />

          <rect x="-216" y="-504" className="st3" width="536" height="680" />
        </g>
      </svg>
    </div>
  );
}
